<template>
<div class="tooltip" :data-tooltip="text">
    <slot></slot>
</div>
</template>

<script>
export default {
    props: {
        text: String
    }
}
</script>


<style lang="scss" scoped>
.tooltip {
    position: relative;

    &::after {
        content: attr(data-tooltip);
        position: absolute;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        // top: 100%;
        // right: -50%;
        transform: scale(0.1);
        transform-origin: 50% top;
        width: 64px;
        height: 25px;
        background: rgba(0, 0, 0, 0.6);
        border-radius: 2px;
        color: #FFF;
        font-size: 10px;
        padding-top: 3px;
        box-sizing: border-box;
        font-weight: 500;
        visibility: hidden;
        transition: transform 0.1s ease-in-out;
    }

    &:hover::after {
        visibility: visible;
        transform: scale(1);
    }
}
</style>
